import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const BulkWorkflowsRoutes: RouteBundle = {
  domain: 'bulk-worflows',
  routes: [
    {
      urlPattern: 'bulk-workflows/assembly',
      handler: EditorRoutes.bulkAssembly.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: 'bulk-workflows/translation',
      handler: EditorRoutes.bulkTranslation.bind(EditorRoutes),
      legacy: true,
    },
  ],
};
